import React from 'react';
import CheckBox from '@ingka/checkbox';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/focus/dist/style.css';

type CheckboxProps = {
  id: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  label?: string;
  checked?: boolean;
  name?: string;
  disabled?: boolean;
};

const SkapaCheckbox = ({ id, label, value, checked, name, onChange, disabled }: CheckboxProps) => {
  return (
    <CheckBox
      id={id}
      label={label}
      value={value}
      name={name}
      onChange={onChange}
      checked={checked}
      disabled={disabled}
    />
  );
};

export default SkapaCheckbox;
